import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import ColorPicker from 'lib/ui/ColorPicker'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import {CountDownTimerSettings} from 'Event/Dashboard/components/CountDownTimer'

export default function AdditionalSection(props: {
  control: UseFormMethods['control']
  countDownTimer: CountDownTimerSettings
  namePrefix?: string
}) {
  const {control, countDownTimer, namePrefix = ''} = props

  return (
    <>
      <CollapsibleSection label={'Additional Settings'}>
        <Controller
          name={`${namePrefix}separatorStyles.color`}
          control={control}
          defaultValue={countDownTimer.separatorStyles.color}
          render={({value, onChange}) => (
            <ColorPicker
              label="Separator Color"
              color={value}
              onPick={onChange}
            />
          )}
        />

        <Controller
          name={`${namePrefix}descriptionStyles.color`}
          control={control}
          defaultValue={countDownTimer.descriptionStyles.color}
          render={({value, onChange}) => (
            <ColorPicker
              label="Description Color"
              color={value}
              onPick={onChange}
            />
          )}
        />
      </CollapsibleSection>
    </>
  )
}
